<template>
    <div>
        <div>
            <h1 class="s-h1">{{title}}</h1>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>
